module.exports = __webpack_public_path__ + "static/media/11111.a9ad6890.JPG";